import { useLayoutEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useEmail } from '@app/api/profile/useEmail';
import { useDialogContext } from '@app/components/dialogs/DialogProvider';
import { ThemeButton } from '@shared/ui/buttons';
import { EmailInput } from '@shared/ui/forms/inputs';
import { validateServerErrors } from '@utils/validation';

export default function EmailNewForm({ setStep, setNewEmail }) {
  const { setSubtitle, setTitle } = useDialogContext();
  const { sendNewEmail } = useEmail();
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm();

  async function onSubmit(formData) {
    try {
      const res = await sendNewEmail(formData);
      if (res) {
        setNewEmail(formData.new_email);
        setStep(4);
      }
    } catch (err) {
      validateServerErrors(setError, err);
    }
  }

  useLayoutEffect(() => {
    setSubtitle('');
    setTitle('new_email');
  }, []);

  return (
    <>
      <DialogContent>
        <EmailInput control={control} errors={errors} name="new_email" />
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          endIcon="chevron-right"
          loading={isSubmitting}
        >
          {t('continue')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
